import React, { useState, useEffect } from "react";

export const HomePage = (params) => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDateTime = (date) => {
    const options = {
      year: "numeric", // 显示年份（如：2023）
      month: "long", // 显示完整月份（如：十一月）
      day: "numeric", // 显示日期（如：15）
      hour: "2-digit", // 显示小时（24小时制）
      minute: "2-digit", // 显示分钟
      second: "2-digit", // 显示秒
      hour12: false, // 使用24小时制
    };
    return date.toLocaleDateString("zh-CN", options);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
        fontSize: "24px",
        fontFamily: "Arial, sans-serif",
        userSelect: "none", // 禁止文本选择
        WebkitUserSelect: "none", // Safari兼容
        MozUserSelect: "none", // Firefox兼容
        msUserSelect: "none", // IE/Edge兼容
        marginTop:"10vh"
      }}
    >
      <div>
        <h1
          style={{
            textAlign: "center",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
          }}
        >
          欢迎来到高校学生综合素质评价系统
        </h1>
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            padding: "15px",
            backgroundColor: "#f0f0f0",
            borderRadius: "5px",
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            userSelect: "none",
            WebkitUserSelect: "none",
            MozUserSelect: "none",
            msUserSelect: "none",
          }}
        >
          当前时间: {formatDateTime(currentDateTime)}
        </p>
      </div>
    </div>
  );
};
